import {AddEditFolder} from "app/employee/organizer/modal/AddEditFolder";
import {FstIonModal} from "app/employee/incdoc/FstIonModal";
import {IonButton, IonFab, IonIcon, IonLabel} from "@ionic/react";
import {ellipsisVerticalCircleOutline} from "ionicons/icons";
import type {OrganizerFragment} from "app/gql/graphqlSchema";
import {useTranslation} from "react-i18next";
import {forwardRef, useCallback, useImperativeHandle, useRef} from "react";
import {useFolderListContextMenu} from "app/employee/organizer/folderList/useFolderListContextMenu";

interface Props {
  organizer: OrganizerFragment;
  onRefresh: () => void | Promise<void>;
}

export interface FolderListFabHandle {
  addFolder: () => void;
}

export const FolderListFab = forwardRef<FolderListFabHandle, Props>(({organizer, onRefresh}, ref) => {
  const {t} = useTranslation();
  const folderRef = useRef<HTMLIonModalElement | null>(null);

  const handleNewFolder = useCallback(() => {
    onRefresh();
  }, [onRefresh]);

  const onAdd = useCallback(() => {
    folderRef.current?.present();
  }, []);

  const {showOptions} = useFolderListContextMenu({onAdd});

  useImperativeHandle(
    ref,
    () => ({
      addFolder: onAdd
    }),
    [onAdd]
  );

  return (
    <>
      <FstIonModal onIonModalDidDismiss={handleNewFolder} ref={folderRef}>
        <AddEditFolder organizerId={organizer.id} />
      </FstIonModal>
      <IonFab horizontal="end" slot="fixed" vertical="bottom">
        <IonButton onClick={showOptions} shape="round">
          <IonIcon icon={ellipsisVerticalCircleOutline} slot="end" />
          <IonLabel>{t("g.action")}</IonLabel>
        </IonButton>
      </IonFab>
    </>
  );
});

FolderListFab.displayName = "FolderListFab";
